export const headersData = [
  {
    value: "NO.",
    accessorKey: "index",
    type: "alphabet",
  },
  {
    value: "Foto TBS",
    accessorKey: "photoFileId",
    type: "alphabet",
  },
  {
    value: "Foto Brondolan",
    accessorKey: "photo2FileId",
    type: "alphabet",
  },
  {
    value: "Tanggal panen",
    accessorKey: "date",
    type: "alphabet",
    sorted: true,
  },
  {
    value: "Dibuat Oleh",
    accessorKey: "createdBy",
    type: "alphabet",
  },
  {
    value: "Komentar",
    accessorKey: "remark",
    type: "alphabet",
  },
  {
    value: "Tanggal Tindakan",
    accessorKey: "caDueDate",
    type: "alphabet",
  },
  {
    value: "Blok",
    accessorKey: "adhocBlockName",
    type: "number",
  },
  {
    value: "TPH",
    accessorKey: "collectionPointName",
    type: "number",
  },
  {
    value: "Latitude",
    accessorKey: "latitude",
    type: "number",
  },
  {
    value: "Longitude",
    accessorKey: "longitude",
    type: "number",
  },
  {
    value: "Total JJG",
    accessorKey: "fruitCount",
    type: "number",
  },
  {
    value: "Buah Mentah",
    accessorKey: "unripeCount",
    type: "number",
  },

  {
    value: "Janjang Kosong ",
    accessorKey: "emptyCount",
    type: "number",
  },
  {
    value: "Buah Busuk",
    accessorKey: "rottenCount",
    type: "number",
  },
  {
    value: "Parthenocarpy",
    accessorKey: "parthenocarpyCount",
    type: "number",
  },
  {
    value: "Abnormal",
    accessorKey: "abnormalCount",
    type: "number",
  },
  {
    value: "Reject Lainnya",
    accessorKey: "rejectFruitCount",
    type: "number",
  },
  {
    value: "Berat Brondolan (kg)",
    accessorKey: "brondolanWeight",
    type: "number",
    sorted: true,
  },
  {
    value: "Total Panen (kg)",
    accessorKey: "totalWeight",
    type: "number",
    sorted: true,
  },
];
